import { Video } from '../data/videos'

const VideoEmbed = ({ video }: { video: Video }) => (
    <div className='video-frame'>
        <iframe
            src={`https://www.youtube.com/embed/${video.id}`}
            title={`O, Kenayda — ${video.title}`}
            loading='lazy'
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            referrerPolicy='strict-origin-when-cross-origin'
            allowFullScreen
        ></iframe>
    </div>
)

export default VideoEmbed
